"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CheckBoxHeader;

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

CheckBoxHeader.propTypes = {
  allRowsSelected: _propTypes["default"].bool,
  onAllRowsSelectionChange: _propTypes["default"].func
};

function CheckBoxHeader(_ref) {
  var allRowsSelected = _ref.allRowsSelected,
      onAllRowsSelectionChange = _ref.onAllRowsSelectionChange;

  var handleChange = function handleChange(e) {
    var checked = e.target.checked;
    var isShiftClick = e.nativeEvent.shiftKey;
    onAllRowsSelectionChange(checked, isShiftClick);
  };

  return /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], {
    color: "primary",
    inputProps: {
      "aria-label": "primary checkbox"
    },
    onChange: handleChange,
    checked: allRowsSelected,
    size: "small",
    style: {
      padding: 0,
      marginLeft: 8
    }
  });
}